import { GET_REFERENCE_BIKE_REQUEST, GET_REFERENCE_BIKE_REQUEST_SUCCESS, GET_REFERENCE_BIKE_REQUEST_FAILURE } from '../constants/get_reference_bike.constants';

export const getReferenceBikeRequest = (model_id, year, mileage) => ({
    type: GET_REFERENCE_BIKE_REQUEST, model_id, year, mileage,
});

export const getReferenceBikeRequestSuccess = data => ({
    type: GET_REFERENCE_BIKE_REQUEST_SUCCESS, data,
});

export const getReferenceBikeRequestFailure = error => ({
    type: GET_REFERENCE_BIKE_REQUEST_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/get_reference_bike.actions.js